import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow-y: auto;
  width: 70vw;
  color: #303030;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 2.4vw);
  margin-top: 2.8vh;
  margin-left: 1.2vw;
  margin-right: 1.2vw;
  box-sizing: border-box;
`

export const HeaderText = styled.h2`
  font-size: 1.4vw;
  font-weight: 700;
  margin: 0;
  color: #303030;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;
  background-color: #eaeaea;
  color: #303030;

  &:hover {
    background-color: #d0d0d0;
  }
`

export const ContentContainer = styled.div`
  padding: 1.2vw;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  color: #303030;
`

export const Section = styled.div`
  background-color: #fff;
  padding: 1vh 0;
  display: flex;
  flex-direction: column;
  gap: 3vh;
  color: #303030;

  &:not(:first-child) {
    border-top: 1px solid #e0e0e0;
    padding-top: 3vh;
  }
`

export const SectionHeader = styled.h3`
  font-size: 1vw;
  font-weight: 700;
  color: #303030;
  margin: 0;
`

export const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3vh 2vw;
  color: #303030;
`

export const DetailItem = styled.div`
  display: grid;
  grid-template-columns: 10vw 1fr;
  align-items: baseline;
  gap: 1vw;
  color: #303030;
`

export const DetailLabel = styled.span`
  font-size: 0.9vw;
  font-weight: 500;
  text-align: left;
  color: #303030;
`

export const DetailValue = styled.span`
  font-size: 0.9vw;
  font-weight: 700;
  text-align: left;
  color: #303030;
  white-space: nowrap;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 2.5vh 1.2vw;
  border-top: 1px solid #e0e0e0;
  color: #303030;
`

export const EditButton = styled.button`
  background-color: #0090d3;
  color: #fff;
  font-size: 0.9vw;
  font-weight: 700;
  padding: 1.75vh 1.5vw;
  border: none;
  border-radius: 2vw;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5vw;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #007ab8;
  }

  img {
    width: 1vw;
    height: 1vw;
  }
`

export const DeleteButton = styled.button`
  background-color: transparent;
  color: #000; 
  font-size: 0.9vw;
  font-weight: 700;
  padding: 1.75vh 1.5vw;
  border: 1px solid #ef4444;
  border-radius: 2vw;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5vw;
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: rgba(239, 68, 68, 0.1);
  }

  img {
    width: 1vw;
    height: 1vw;
    
    filter: sepia(1) saturate(5) hue-rotate(-10deg);
  }
`
